<template>
    <el-dropdown placement="bottom-start" trigger="click" class="ticket-dropdown">
        <span class="dropdown-trigger">
            <el-tooltip content="Tickets" placement="bottom">
              <Tickets :size="24" class="has-text-light" />
            </el-tooltip>
        </span>
        <template #dropdown>
            <el-dropdown-menu style="width:300px!important;">
                <el-dropdown-item >
                    <strong class="text-primary" style="font-size: 1.1rem;line-height: 1;display: inline-block;">Gestión de tickets</strong>
                </el-dropdown-item>
                <el-dropdown-item @click="modal_create_ticket = true">
                    <font-awesome-icon :icon="['fas', 'plus']" class="icon-option" />
                    <span>Crear ticket</span>
                </el-dropdown-item>
                <el-dropdown-item @click="$router.push('/tickets')">
                    <font-awesome-icon :icon="['fas', 'list']" class="icon-option" />
                    <span>Lista de tickets</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
  </el-dropdown>

  <el-dialog 
        v-model="modal_create_ticket"
        class="modal-lg"
        :close-on-click-modal="false"
    >
      <component-create-ticket :close-modal-parent="closeModal" />
        
  </el-dialog>

</template>
<script>

import ComponentCreateTicket from './componentCreateTicket.vue'
import { Tickets } from 'lucide-vue-next'

export default {
    name: "drawer-publications",
    components: {
        ComponentCreateTicket,
        Tickets
    },
    data() {
        return {
            modal_create_ticket: false,
        }
    },
    mounted() {
    },

    created() {
        
    },
    methods: {
        // Métodos específicos para crear tickets si es necesario
        closeModal() {
            this.modal_create_ticket = false;
        }
    },
    computed: {
        
    },
    

    
}
</script>

  
<style>
.ticket-dropdown {
  display: inline-block;
}
.dropdown-trigger {
  cursor: pointer;
  /* padding: 6px 10px; */
  border-radius: 50%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
}
.icon-menu {
  font-size: 25px;
  color: #409eff;
}
.icon-option {
  margin-right: 8px;
  font-size: 22px;
  color: #606266;
}
.el-dropdown-menu__item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
}
.el-dialog__header {
    padding-bottom: unset!important;
}
</style>  